<script>
  import { Banner, Button } from 'flowbite-svelte';
  import { onMount } from 'svelte';
  import { _ } from 'svelte-i18n';
  import { trackEvent } from '@button/ui/utils';

  export let position = 'bottom';
  export let divClass;

  let shouldShowCookieConsent = true;

  onMount(async () => {
    shouldShowCookieConsent = !localStorage.getItem('analytics_storage');
  });
</script>

{#if shouldShowCookieConsent}
  <Banner {divClass} {position} bannerType="bottom" dismissable={false}>
    <div class="flex flex-1 flex-col items-center gap-4 md:flex-row">
      <div class="flex flex-1 flex-col gap-2 text-sm">
        <p>
          {$_('_shared.cookieConsent.body', {
            default:
              'We use cookies for functionality that allow users to access features, interact with our site and to analyze our traffic.',
          })}
        </p>
        <ol class="list-inside list-decimal space-y-1 ps-5">
          <li>
            {$_('_shared.cookieConsent.necessary', {
              default:
                'Necessary cookies help make a website usable by enabling users to access certain pages and navigate effectively within the website.',
            })}
          </li>
          <li>
            {$_('_shared.cookieConsent.statistic', {
              default:
                'Statistic cookies help website owners to understand how visitors interact with websites by collecting and reporting information anonymously.',
            })}
          </li>
        </ol>
        <p>
          {$_('_shared.cookieConsent.seeOur-', {
            default: 'See our ',
          })}<a
            class="text-buttonBlue/70"
            href="https://www.usebutton.com/support/privacy-policy"
            target="_blank"
            >{$_('_shared.cookieConsent.cta.privacyPolicy', {
              default: 'Privacy Policy',
            })}</a
          >
          {$_('_shared.cookieConsent.-forMoreInfo', {
            default:
              ' for more information on why the use of certain cookies is necessary.',
          })}
        </p>
        <p>
          {$_('_shared.cookieConsent.preference', {
            default: 'Please let us know your preferences.',
          })}
        </p>
      </div>
      <div class="flex w-full flex-col gap-2 md:w-auto md:flex-row">
        <Button
          class="w-full"
          type="button"
          color="alternative"
          on:click={() => {
            trackEvent('consent', 'update', {
              analytics_storage: 'denied',
            });
            shouldShowCookieConsent = false;
            localStorage.setItem('analytics_storage', 'denied');
          }}
          >{$_('_shared.cookieConsent.cta.acceptNecessary', {
            default: 'Accept Necessary',
          })}</Button
        >
        <!-- svelte-ignore missing-declaration -->
        <Button
          class="w-full"
          type="button"
          on:click={() => {
            trackEvent('consent', 'update', {
              analytics_storage: 'granted',
            });
            shouldShowCookieConsent = false;
            localStorage.setItem('analytics_storage', 'granted');
          }}
          >{$_('_shared.cookieConsent.cta.acceptAll', {
            default: 'Accept All',
          })}</Button
        >
      </div>
    </div>
  </Banner>
{/if}
